exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gh-button-call[data-v-dffff8ee]{text-decoration:none}.v-icon[data-v-dffff8ee]{margin:0 10px}", ""]);

// exports
